import React, { Component } from "react";
import { GoArrowRight } from "react-icons/go";
import { ImMinus } from "react-icons/im";

class Resume extends Component {
  render() {
    if (this.props.data) {
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function (education) {
        return (
          <div key={education.school}>
            <h3>{education.school}</h3>
            <p className="info">
              {education.degree} <span>&bull;</span>
              <em className="date">{education.graduated}</em>
            </p>
            <p>{education.description}</p>
          </div>
        );
      });
      var work = this.props.data.work.map(function (work) {
        return (
          <div key={work.id}>
            <h3>{work.company}</h3>
            <p className="info">
              {work.title}
              <span>&bull;</span> <em className="date">{work.years}</em>
            </p>
            <p>{work.description}</p>
          </div>
        );
      });
      var certs = (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            margin: "0 auto",
          }}
        >
          {this.props.data.certifications.map(function (certifications) {
            if (certifications.haveIEarnedYet) {
              return (
                <div
                  key={certifications.id}
                  style={{
                    flex: "1 1 45%",
                    boxSizing: "border-box",
                    margin: "10px",
                    maxWidth: "500px",
                  }}
                >
                  <h3>{certifications.name}</h3>
                  <p className="info" style={{ marginBottom: 0 }}>
                    {certifications.dateEarned}
                  </p>
                  <img
                    src={"/images/certs/" + certifications.logo}
                    alt="Certification Logo"
                    style={{
                      width: 250,
                      margin: "0 auto",
                      display: "block",
                    }}
                  />
                </div>
              );
            } else {
              return;
            }
          })}
        </div>
      );
      var languages = this.props.data.languages.map(function (languages) {
        var className = "bar-expand " + languages.name.toLowerCase();
        var topValue = (languages.improvementIntensity===26 ? "8px" : "5px");
        return (
          <li key={languages.name} style={{zIndex:1}}>
            <span style={{ width: languages.level, background: languages.barColor, zIndex:-1 }} className={className}>
              {languages.latelyImprovement ? 
              <GoArrowRight className="slide-arrow" size={languages.improvementIntensity} style={{zIndex:3, color: "#11ab00", position: "relative", top: topValue, left: "100%", marginLeft: "27.5px"}}></GoArrowRight>
              : 
              <ImMinus size={languages.improvementIntensity} style={{zIndex:3, color: "#de9b00", position: "relative", top: "5px", left: "100%", marginLeft: "35px"}}></ImMinus>
              }
            </span>
            <em>{languages.name}</em>
          </li>
        );
      });
      var frameworks = this.props.data.frameworks.map(function (frameworks) {
        var className = "bar-expand " + frameworks.name.toLowerCase();
        var topValue = (frameworks.improvementIntensity===26 ? "8px" : "5px");
        return (
          <li key={frameworks.name} style={{zIndex:1}}>
            <span style={{ width: frameworks.level, background: frameworks.barColor, zIndex:-1 }} className={className}>
              {frameworks.latelyImprovement ? 
                <GoArrowRight className="slide-arrow" size={frameworks.improvementIntensity} style={{zIndex:3, color: "#11ab00", position: "relative", top: topValue, left: "100%", marginLeft: "27.5px"}}></GoArrowRight>
                : 
                <ImMinus size={frameworks.improvementIntensity} style={{zIndex:3, color: "#de9b00", position: "relative", top: topValue, left: "100%", marginLeft: "35px"}}></ImMinus>
              }
            </span>
            <em>{frameworks.name}</em>
          </li>
        );
      });
      var etcTech = this.props.data.etcTech.map(function (etcTech) {
        var className = "bar-expand " + etcTech.name.toLowerCase();
        var topValue = (etcTech.improvementIntensity===26 ? "8px" : "5px");
        return (
          <li key={etcTech.name} style={{zIndex:1}}>
            <span style={{ width: etcTech.level, background: etcTech.barColor, zIndex:-1 }} className={className}>
            {etcTech.latelyImprovement ? 
              <GoArrowRight className="slide-arrow" size={etcTech.improvementIntensity} style={{zIndex:3, color: "#11ab00", position: "relative", top: topValue, left: "100%", marginLeft: "27.5px"}}></GoArrowRight>
              : 
              <ImMinus size={etcTech.improvementIntensity} style={{zIndex:3, color: "#de9b00", position: "relative", top: topValue, left: "100%", marginLeft: "35px"}}></ImMinus>
            }
            </span>
            <em>{etcTech.name}</em>
          </li>
        );
      });
    }

    return (
      <section id="resume">
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">{education}</div>
            </div>
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Experience</span>
            </h1>
          </div>

          <div className="nine columns main-col">{work}</div>
        </div>

        {/* <div className="row skill">
          <div className="four columns header-col">
            <h1>
              <span>Certifications</span>
            </h1>
          </div>

          <div className="ten columns main-col">
            <div className="bars" >
              <ul className="skills">{certs}</ul>
            </div>
          </div>
        </div> */}

        <div className="row skill">
          <div className="four columns header-col">
            <h1>
              <span>Languages</span>
            </h1>
          </div>

          <div className="eight columns main-col">
            <p>{skillmessage}</p>
            
            <div className="bars" >
              <ul className="skills">{languages}</ul>
            </div>
          </div>
        </div>

        <div className="row skill">
          <div className="four columns header-col">
            <h1>
              <span>Frameworks/Libraries</span>
            </h1>
          </div>

          <div className="eight columns main-col">
            <p>{skillmessage}</p>

            <div className="bars">
              <ul className="skills">{frameworks}</ul>
            </div>
          </div>
        </div>

        <div className="row skill">
          <div className="four columns header-col">
            <h1>
              <span>Other Tech/Services</span>
            </h1>
          </div>

          <div className="eight columns main-col">
            <p>{skillmessage}</p>

            <div className="bars">
              <ul className="skills">{etcTech}</ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/Resume.js